var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 28 32",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1999 9.79964H24.9999L21.7499 1.59964C21.4999 0.999643 20.8499 0.749643 20.2999 0.949643C19.6999 1.19964 19.4499 1.84964 19.6499 2.39964L22.5499 9.79964H5.4499L8.3499 2.44964C8.5999 1.84964 8.2999 1.19964 7.6999 0.999643C7.1499 0.749643 6.4999 0.999643 6.2499 1.59964L2.9999 9.79964H1.7999C0.899902 9.79964 0.149902 10.5496 0.149902 11.4496V15.4996C0.149902 16.3496 0.749902 16.9996 1.5999 17.0996L2.8499 27.9996C3.0499 29.7996 4.5499 31.1496 6.3499 31.1496H21.6499C23.4499 31.1496 24.9499 29.7996 25.1499 27.9996L26.3999 17.0996C27.1999 16.9996 27.8499 16.2996 27.8499 15.4996V11.3996C27.8499 10.4996 27.0999 9.79964 26.1999 9.79964ZM2.3999 12.0496H25.5999V14.8996H2.3999V12.0496ZM21.6499 28.8996H6.3499C5.6999 28.8996 5.1499 28.3996 5.0499 27.7496L3.8499 17.1496H24.1499L22.9499 27.7496C22.8499 28.3996 22.2999 28.8996 21.6499 28.8996Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 19.3994C8.3 19.3994 7.75 19.8994 7.75 20.5494V24.2994C7.75 24.8994 8.25 25.4494 8.9 25.4494C9.55 25.4494 10.05 24.9494 10.05 24.2994V20.4994C10.05 19.8994 9.55 19.3994 8.9 19.3994Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0997 19.3994C18.4997 19.3994 17.9497 19.8994 17.9497 20.5494V24.2994C17.9497 24.8994 18.4497 25.4494 19.0997 25.4494C19.7497 25.4494 20.2497 24.9494 20.2497 24.2994V20.4994C20.1997 19.8994 19.6997 19.3994 19.0997 19.3994Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.acbd6722834b4975c490cd315e054e9f.svg";
export { ForwardRef as ReactComponent };